import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { formatString } from '../../utils/string-utils';

@Injectable({
  providedIn: 'root'
})
export class AiService {

	registry: any = {
        "local_llm": {
            prompt_url: '/aw-server/rest/ai/kvllm/prompt',
            summarize_url: undefined,
            ping_url: '/aw-server/rest/ai/kvllm/ping',
            name: 'KV AI'
        },
        "open_ai": {
            prompt_url: '/aw-server/rest/ai/openai/extract/{0}/{1}/{2}?update={3}',
            summarize_url: '/aw-server/rest/ai/openai/summarize',
            ping_url: '/aw-server/rest/ai/openai/ping',
			models_url: '/aw-server/rest/ai/openai/models',
            name: 'OpenAI'
        }
    };

	constructor(private http: HttpClient) {}
	
	async ping(svc_type: string): Promise<any> {
		let url = this.registry[svc_type].ping_url;
	
		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(false);
		}
	}
	
	async getModels(svc_type: string): Promise<any> {
		let url = this.registry[svc_type].models_url;
		
		if (!url) {
			return Promise.reject(false);
		}
	
		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(false);
		}
	}
	
	async generateSummaries(ids: any[]): Promise<any> {
		let url = this.registry["open_ai"].summarize_url;
	
		try {
			return await firstValueFrom(this.http.post<any>(url, ids));
		} catch (error) {
			return Promise.reject(false);
		}
	}
	
	async extract(flavor: string, ids: any[], userinput: string, doUpdate: boolean, model?: any): Promise<any> {
		let idsStr = ids.join(",");
		
		let url = this.registry["open_ai"].prompt_url;
		url = formatString(url, flavor, idsStr, encodeURIComponent(userinput), doUpdate);
		if (model) {
			url = url + '&model=' + model;
		}		

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(false);
		}
	}
	
	async promptLLM(ids: any[], userinput: string, ismock: boolean): Promise<any> {
		// Posting IDs is TBD
		//let idsStr = ids.join(",");
		
	    let url = this.registry["local_llm"].prompt_url;
	    if (ismock) {
	        url = url + '?mock=true';
	    }
		
	    let payload = {
	        "prompt": userinput
	    };				

		try {
			return await firstValueFrom(this.http.post<any>(url, payload));
		} catch (error) {
			return Promise.reject(false);
		}
	}		
}
